import I1 from "../img/i1.png";
import Shake from "../img/d7.png";
import Falooda from "../img/i7.png";
import BlueLagoon from "../img/d4.png";

export const heroData = [
  {
    id: "1",
    name: "Icecream",
    desc: "Chocolate",
    imgSrc: I1,
  },
  {
    id: "2",
    name: "Shake",
    desc: "Badam",
    imgSrc: Shake,
  },
  {
    id: "3",
    name: "Falooda",
    desc: "Strawberry",
    imgSrc: Falooda,
  },
  {
    id: "4",
    name: "Mocktail",
    desc: "Blue Lagoon",
    imgSrc: BlueLagoon,
  },
];

export const categories = [
  { id: "1", name: "Icecream", urlParamName: "icecreams" },

  { id: "2", name: "Shake", urlParamName: "shake" },

  { id: "3", name: "Falooda", urlParamName: "falooda" },

  { id: "4", name: "Cold Coffee", urlParamName: "coldcoffee" },

  { id: "5", name: "Mocktail", urlParamName: "mocktail" },

  { id: "6", name: "Snacks", urlParamName: "snacks" },

  { id: "7", name: "Corn", urlParamName: "corn" },

  { id: "8", name: "Family Pack", urlParamName: "familypack" },
];
